import React from 'react';
import { Section } from './Section';
export function Proof() {
  return <div className="bg-blood text-white py-24 px-6 relative overflow-hidden" data-id="element-210">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E')] opacity-10 mix-blend-overlay pointer-events-none" data-id="element-211"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-212">
        <p className="text-2xl md:text-4xl font-serif italic leading-relaxed font-medium" data-id="element-213">
          "En los próximos 7 días, notarás algo diferente: la gente empezará a
          medir sus palabras antes de hablar contigo. Al dejar de reaccionar de
          forma predecible, el equilibrio de poder se inclinará a tu favor de
          manera natural, sin necesidad de gritar o pelear."
        </p>
      </div>
    </div>;
}